/* eslint-disable camelcase */
import React from 'react';
import cn from 'classnames';
import PropTypes from 'prop-types';
import { Menu, Icon, LocaleProvider, Modal, Alert } from 'antd';
import antdCss from 'antd/dist/antd.css';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import zhCN from 'antd/lib/locale-provider/zh_CN';
import Link from '../../components/Link';
import xfetch from '../../xfetch';
import s from './Admin.css';
import Header from '../Header/Admin';
import Context from './Context';

const { SubMenu } = Menu;
class Layout extends React.Component {
  static propTypes = {
    children: PropTypes.node.isRequired,
    pathname: PropTypes.string.isRequired,
  };

  state = {
    loaded: false,
    user: {},
    settings: {},
    unbindOrgModalVisible: false,
  };

  componentDidMount() {
    const api = `${window.G.backendApi}/profiles/staff/mine/`;
    this.getSettings().then(res => {
      const settings = res.length ? res[0] : res;
      xfetch(api).then(({ error, result }) => {
        const { sso_server, client_id, redirect_uri } = window.G.oauth2;
        const ssoLogin = `${sso_server}?client_id=${client_id}&redirect_uri=${redirect_uri}`;
        const enableSSO =
          settings.enabled_model &&
          settings.enabled_model.indexOf('oauth2') !== -1;
        if (error) {
          window.location.href = enableSSO ? ssoLogin : '/login';
          return;
        }
        this.setState({ loaded: true, user: result });
        if (result.role === 'site_manager' && !result.organization) {
          this.setState({
            unbindOrgModalVisible: true,
          });
        }
      });
    });
  }

  getSettings = async () => {
    const { error, result } = await xfetch(
      `${window.G.backendApi}/system/settings/`,
    );
    return new Promise(resolve => {
      if (error) {
        return resolve({});
      }
      const settings = result.length ? result[0] : {};
      document.title = settings.title;
      this.setState({
        settings,
      });
      return resolve(result);
    });
  };

  triggerCollapse = collapsed => this.setState({ collapsed });

  render() {
    const {
      loaded,
      user,
      collapsed,
      settings,
      unbindOrgModalVisible,
    } = this.state;
    const { pathname } = this.props;
    const { role } = user;
    const isSuper = role === 'superuser';
    const isManager = role === 'site_manager';

    if (!loaded) {
      return null;
    }

    const defaultOpenKeys =
      pathname.split('/').length > 3
        ? pathname.replace(/(.*)\/.+$/, '$1')
        : pathname;

    const enableSider =
      settings.enabled_model && settings.enabled_model.indexOf('spider') !== -1;

    return (
      <LocaleProvider locale={zhCN}>
        <div>
          <div className={s.wrap}>
            <div className={cn(s.side, { [s.collapsed]: collapsed })}>
              <Menu
                defaultSelectedKeys={[pathname]}
                defaultOpenKeys={[defaultOpenKeys]}
                mode="inline"
                theme="dark"
                inlineCollapsed={collapsed}
              >
                <Menu.Item key="" className={s.brandItem}>
                  <span className={s.brand}>AI政务机器人</span>
                  {/* <Link className={s.brand} to="/">
                    <img
                      src="/assets/images/logo.png"
                      alt="logo"
                      className={s.logo}
                    />
                     <span className={s.brandTxt}>政博士</span> 
                  </Link> */}
                </Menu.Item>
                {isManager && !user.organization ? (
                  <Menu.Item key="no-premission">
                    <span>暂无权限访问</span>
                  </Menu.Item>
                ) : (
                  [
                    <SubMenu
                      key="/admin/knowledge"
                      title={
                        <span>
                          <Icon type="book" />
                          <span>知识库</span>
                        </span>
                      }
                    >
                      {isSuper && (
                        <Menu.Item key="/admin/knowledge/category">
                          <Link to="/admin/knowledge/category">
                            <span>知识分类</span>
                          </Link>
                        </Menu.Item>
                      )}
                      <Menu.Item key="/admin/knowledge/question">
                        <Link to="/admin/knowledge/question">
                          <span>问题管理</span>
                        </Link>
                      </Menu.Item>
                      {isSuper && (
                        <Menu.Item key="/admin/knowledge/knowledge">
                          <Link to="/admin/knowledge/knowledge">
                            <span>知识点管理</span>
                          </Link>
                        </Menu.Item>
                      )}
                      {isSuper && (
                        <Menu.Item key="/admin/knowledge/words">
                          <Link to="/admin/knowledge/words">
                            <span>敏感词管理</span>
                          </Link>
                        </Menu.Item>
                      )}
                      {isSuper && (
                        <Menu.Item key="/admin/knowledge/people-words">
                          <Link to="/admin/knowledge/people-words">
                            <span>百姓体词库</span>
                          </Link>
                        </Menu.Item>
                      )}
                      <Menu.Item key="/admin/knowledge/learn">
                        <Link to="/admin/knowledge/learn">
                          <span>未知问题学习</span>
                        </Link>
                      </Menu.Item>
                    </SubMenu>,
                    isSuper && (
                      <SubMenu
                        key="/admin/org"
                        title={
                          <span>
                            <Icon type="team" />
                            <span>组织用户</span>
                          </span>
                        }
                      >
                        <Menu.Item key="/admin/org/structure">
                          <Link to="/admin/org/structure">
                            <span>组织管理</span>
                          </Link>
                        </Menu.Item>
                        <Menu.Item key="/admin/org/user">
                          <Link to="/admin/org/user">
                            <span>用户管理</span>
                          </Link>
                        </Menu.Item>
                      </SubMenu>
                    ),
                    isSuper && (
                      <SubMenu
                        key="/admin/history"
                        title={
                          <span>
                            <Icon type="bars" />
                            <span>操作日志</span>
                          </span>
                        }
                      >
                        <Menu.Item key="/admin/history/answer">
                          <Link to="/admin/history/answer">
                            <span>答案日志</span>
                          </Link>
                        </Menu.Item>
                        <Menu.Item key="/admin/history/question">
                          <Link to="/admin/history/question">
                            <span>问题日志</span>
                          </Link>
                        </Menu.Item>
                        <Menu.Item key="/admin/history/words">
                          <Link to="/admin/history/words">
                            <span>敏感词日志</span>
                          </Link>
                        </Menu.Item>
                        <Menu.Item key="/admin/history/unknown_question">
                          <Link to="/admin/history/unknown_question">
                            <span>未知问题日志</span>
                          </Link>
                        </Menu.Item>
                        <Menu.Item key="/admin/history/spider">
                          <Link to="/admin/history/spider">
                            <span>采集任务日志</span>
                          </Link>
                        </Menu.Item>
                      </SubMenu>
                    ),
                    <Menu.Item key="/admin/statistics">
                      <Link to="/admin/statistics">
                        <Icon type="line-chart" />
                        <span>数据统计</span>
                      </Link>
                    </Menu.Item>,
                    enableSider && (
                      <Menu.Item key="/admin/spider">
                        <Link to="/admin/spider">
                          <Icon type="deployment-unit" />
                          <span>数据采集</span>
                        </Link>
                      </Menu.Item>
                    ),
                    <Menu.Item key="/admin/setting">
                      <Link to="/admin/setting">
                        <Icon type="setting" />
                        <span>系统设置</span>
                      </Link>
                    </Menu.Item>,
                    settings.enabled_model &&
                      settings.enabled_model.includes('plugin') && (
                        <Menu.Item key="/admin/plugin">
                          <Link to="/admin/plugin">
                            <Icon type="usb" />
                            <span>插件管理</span>
                          </Link>
                        </Menu.Item>
                      ),
                  ]
                )}
              </Menu>
            </div>
            <div className={s.main} id="js-main">
              <Header
                user={user}
                lang="cn"
                collapsed={collapsed}
                triggerCollapse={this.triggerCollapse}
                enabledModel={settings.enabled_model}
              />
              <div className={cn(s.children, 'admin-children')}>
                {isManager && !user.organization ? (
                  <div style={{ padding: 20 }}>
                    <Alert
                      type="warning"
                      message="您当前身份为子站管理员且未关联任何组织， 请联系超级管理员关联组织后再次登录管理您的站点或切换账号登录。"
                    />
                  </div>
                ) : (
                  <Context.Provider value={this.state}>
                    {this.props.children}
                  </Context.Provider>
                )}
              </div>
            </div>
          </div>
          <Modal
            title={
              <div>
                <Icon type="exclamation-circle" /> 系统提示
              </div>
            }
            visible={unbindOrgModalVisible}
            onCancel={() => this.setState({ unbindOrgModalVisible: false })}
            onOk={() => this.setState({ unbindOrgModalVisible: false })}
          >
            <Alert
              type="warning"
              message="您当前身份为子站管理员且未关联任何组织， 请联系超级管理员关联组织后再次登录管理您的站点。"
            />
          </Modal>
        </div>
      </LocaleProvider>
    );
  }
}

export default withStyles(antdCss, s)(Layout);
